import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { SelectTagsPopupModel } from 'src/app/_models/claimant-on-web/claimant-on-web';
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
    selector: 'formly-tag',
    templateUrl: "./formly-tag-input.component.html",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule]
})
export class FormlyTagComponent extends FieldType {

  inputModel: SelectTagsPopupModel;
  showCreateTagPanel: boolean = false;
  public ICONS = ICONS;
  fnOpenCreateTagPanel() {
    this.inputModel = new SelectTagsPopupModel();
    this.inputModel.tagList = this.formControl.value;
    this.inputModel.claimantId = this.model.userId;
    this.inputModel.claimantName = this.model.userName;
    this.showCreateTagPanel = true;
  }

  fnSelectCreateTag(data) {
    if (data && data.tagList) {
      this.formControl.setValue(data.tagList);
      this.to.change(this.field, data);
    }
    this.fnCloseCreateTagPanel(true);
  }

  fnCloseCreateTagPanel(isClose: boolean) {
    if (isClose) {
      this.showCreateTagPanel = false;
    }
  }

}
